export const ACCOUNT_PARAM_NAME = 'accountId';
export const PERFORMANCE_RULES_ID_PARAM = 'ruleId';

export const ACCOUNT_NAME_PARAM_TEMPLATE = `/:${ACCOUNT_PARAM_NAME}?`;
export const PERFORMANCE_RULES_ID_PARAM_TEMPLATE = `/:${PERFORMANCE_RULES_ID_PARAM}?`;
